<template>
  <div style="width:100%">
    <header class="head-top" :class="!isScrollTop ? 'no-fixed' : ''">
      <div class="h-top">
        <div style="max-width: 1030px;width: 1030px;margin: auto 0;">
          <div class="welcome">
            <div
              v-if="!isScroll"
              style="width:440px;margin-top:-5px;display:flex;align-items: center;"
            >
              <img
                src="@/assets/images/logo-w.jpg"
                style="height:48px; width: auto;"
                alt
              />
              <p
                style="font-weight: bold;font-size: 20px;color:#ffffff"
              >
                KVAC E-form System
              </p>
            </div>
            <div v-else style="width:440px;margin-top:-5px;display:flex;align-items: center;">
              <img
                src="@/assets/images/logo.jpg"
                style="height:48px; width: auto;"
                alt
              />
              <p
                style="font-weight: bold;font-size: 20px;color:#112e58"
              >
                KVAC E-form System
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div :style="{ height: isScrollTop ? '70px' : '0px' }"></div>
  </div>
</template>

<script>
export default {
  props: {},
  computed: {},
  props: {
    isScrollTop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isScroll: false,
      currLang: "简体中文",
      lanShow: false,
    };
  },
  mounted() {
    const that = this;
    // if (this.servicePhone && this.servicePhone != '') {
    // } else {
    //     this.get400Phone()
    // }
    if (this.isScrollTop) {
      var e_top = $(".head-top");
      var startPos = 0;
      $.event.add(window, "scroll", function() {
        var p = $(window).scrollTop();
        if (p > startPos) {
          $(e_top).addClass("head-f-top");
          that.isScroll = true;
        } else {
          $(e_top).removeClass("head-f-top");
          that.isScroll = false;
        }
      });
    }

    if (localStorage.getItem("langLocale")) {
      this.$i18n.locale = localStorage.getItem("langLocale");
    }
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("langLocale", lang);
      location.reload();
    },
    toggleShow() {
      this.lanShow = !this.lanShow;
    },
    navTo(name) {
      this.$router.push({ name });
    },
  },
};
</script>
<style scoped>
.welcome {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue